export default function () {
  const btn = $('#nav-btn');
  const links = $(".menu-mobile a[href^='#']");
  const contact_btn = $(".menu-mobile + a[href^='#']");

  const toggle = (id) => {
    btn.toggleClass('nav-btn--active');
    $('#menu-mobile').toggleClass('menu-animation--active');
    document.body.style.overflowY = btn.hasClass('nav-btn--active')
      ? 'hidden'
      : 'auto';

    if (id) {
      $('html, body').animate(
        {
          scrollTop: $(`[data-id="${id.replace('#', '')}"]`).offset().top,
        },
        300
      );
    }
  };

  btn.on('click', () => toggle(false));
  if (links)
    links.on('click', function () {
      toggle($(this).attr('href'));
    });
  if (contact_btn)
    contact_btn.on('click', function () {
      toggle($(this).attr('href'));
    });
}
